<template>
  <!--月日年选择根据不同的类型返回不同的时间-->
  <div class="dmyDateSelector row flex-center">
    <el-radio-group
      v-if="selecttype.length > 1"
      @change="changeDatePicker"
      v-model="labelStatus"
    >
      <el-radio-button v-if="selecttype.includes('0')" label="0">
        日
      </el-radio-button>
      <el-radio-button v-if="selecttype.includes('1')" label="1">
        月
      </el-radio-button>
      <el-radio-button v-if="selecttype.includes('2')" label="2">
        年
      </el-radio-button>
    </el-radio-group>

    <div v-show="labelStatus === '0'">
      <el-date-picker
        :style="{
          borderRadius: '0px 0px 0px 0px',
          borderLeft: 'none',
          borderRight: 'none',
          width: labelWidth,
        }"
        :class="
          selecttype.length == 1 ? 'timebordernone-right' : 'timebordernone'
        "
        align="right"
        unlink-panels
        v-model="timeValue"
        value-format="YYYY-MM-DD"
        :type="pickertype"
        :clearable="false"
        @change="changeday"
        placeholder="选择日期"
        :shortcuts="daypickerOptions"
      >
      </el-date-picker>
    </div>

    <div v-show="labelStatus === '1'">
      <el-date-picker
        :style="{
          borderRadius: '0px 0px 0px 0px',
          borderLeft: 'none',
          borderRight: 'none',
          width: labelWidth,
        }"
        :class="
          selecttype.length == 1 ? 'timebordernone-right' : 'timebordernone'
        "
        class="timebordernone"
        align="right"
        unlink-panels
        v-model="timeValue"
        value-format="YYYY-MM"
        type="month"
        :clearable="false"
        @change="changemonth"
        placeholder="选择月份"
        :shortcuts="monthpickerOptions"
      >
      </el-date-picker>
    </div>

    <div v-show="labelStatus === '2'">
      <el-date-picker
        :style="{
          borderRadius: '0px 0px 0px 0px',
          borderLeft: 'none',
          borderRight: 'none',
          width: labelWidth,
        }"
        :class="
          selecttype.length == 1 ? 'timebordernone-right' : 'timebordernone'
        "
        class="timebordernone"
        align="right"
        unlink-panels
        v-model="timeValue"
        value-format="YYYY"
        type="year"
        :clearable="false"
        @change="changeyear"
        placeholder="选择年份"
      >
      </el-date-picker>
    </div>
    <div class="center-button" @click="backToCurrent" v-if="showCenterButton">
      今
    </div>
    <div class="right-button">
      <div @click="changePrevNext(-1)">
        <el-icon><ArrowLeft /></el-icon>
      </div>
      <div @click="changePrevNext(1)">
        <el-icon><ArrowRight /></el-icon>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { ArrowLeft, ArrowRight } from "@element-plus/icons-vue";
import { getToday } from "@/util/date.js";

import func from "@/util/func";

export default {
  name: "dmyDateSelector",
  emits: ["changeLeftPicker", "changeTimePicker"],
  props: {
    form: {
      type: Object,
      required: false,
      default: () => ({
        date: [],
      }),
    },
    selecttype: {
      type: Array,
      required: false,
      default: () => ["0", "1", "2"],
    },
    formvalue: {
      type: Array,
      required: false,
      default: () => [],
    },
    pickertype: {
      type: String,
      default: "date",
    },
    showCenterButton: {
      type: Boolean,
      default: false,
    },
  },
  components: { ArrowLeft, ArrowRight },
  data: function () {
    return {
      labelWidth: "150px",
      labelStatus: "0",
      timeValue: getToday()[0],
      daypickerOptions: [
        {
          text: "今天",
          value: new Date(),
        },
        {
          text: "昨天",
          value: (() => {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            return date;
          })(),
        },
      ],
      monthpickerOptions: [
        {
          text: "上月",
          value: (() => {
            const start = new Date();
            start.setDate(1);
            start.setMonth(start.getMonth() - 1);
            return start;
          })(),
        },
        {
          text: "本月",
          value: (() => {
            const start = new Date();
            start.setDate(1);
            return start;
          })(),
        },
      ],
    };
  },
  mounted: function () {
    this.format();
  },
  watch: {
    "form.date": {
      handler() {
        this.format();
      },
      deep: true,
    },
    selecttype: {
      handler() {
        this.format();
      },
      deep: true,
    },
  },
  methods: {
    format() {
      let that = this;
      that.labelStatus = that.selecttype[0];
      if (!func.isEmpty(that.form.date)) {
        if (!Array.isArray(that.form.date)) {
          that.timeValue = that.normalizeTimeValue(
            that.form.date,
            that.labelStatus,
          );
        } else {
          that.timeValue = that.normalizeTimeValue(
            that.form.date[0],
            that.labelStatus,
          );
        }
      } else {
        that.timeValue = that.normalizeTimeValue(
          getToday()[0],
          that.labelStatus,
        );
      }
    },
    normalizeTimeValue(value, type) {
      const targetValue = value || getToday()[0];
      switch (type) {
        case "1":
          return moment(targetValue).format("YYYY-MM");
        case "2":
          return moment(targetValue).format("YYYY");
        default:
          return moment(targetValue).format("YYYY-MM-DD");
      }
    },
    changeDatePicker(e) {
      let that = this;
      let startDate, endDate;
      switch (e) {
        case "0":
          //日
          that.timeValue = that.normalizeTimeValue(that.timeValue, e);
          that.$emit("changeLeftPicker", {
            time: [that.timeValue, that.timeValue],
            type: e,
          });
          break;
        case "1":
          //月
          that.timeValue = that.normalizeTimeValue(that.timeValue, e);
          startDate = moment(that.timeValue)
            .startOf("month")
            .format("YYYY-MM-DD");
          endDate = moment(that.timeValue).endOf("month").format("YYYY-MM-DD");
          that.$emit("changeLeftPicker", {
            time: [startDate, endDate],
            type: e,
          });
          break;
        case "2":
          //年
          that.timeValue = that.normalizeTimeValue(that.timeValue, e);
          startDate = moment(that.timeValue)
            .startOf("years")
            .format("YYYY-MM-DD");
          endDate = moment(that.timeValue).endOf("years").format("YYYY-MM-DD");
          that.$emit("changeLeftPicker", {
            time: [startDate, endDate],
            type: e,
          });
          break;

        default:
          break;
      }
    },
    changeday(e) {
      let that = this;
      that.$emit("changeTimePicker", { time: [e, e] });
    },
    changemonth(e) {
      let that = this;
      let startDate, endDate;
      startDate = moment(e).startOf("month").format("YYYY-MM-DD");
      endDate = moment(e).endOf("month").format("YYYY-MM-DD");
      that.$emit("changeTimePicker", { time: [startDate, endDate] });
    },
    changeyear(e) {
      let that = this;
      let startDate, endDate;
      startDate = moment(e).startOf("years").format("YYYY-MM-DD");
      endDate = moment(e).endOf("years").format("YYYY-MM-DD");
      that.$emit("changeTimePicker", { time: [startDate, endDate] });
    },
    changePrevNext(val) {
      let that = this;
      switch (that.labelStatus) {
        case "0":
          that.timeValue = moment(that.timeValue)
            .add(val, "days")
            .format("YYYY-MM-DD");
          that.changeday(that.timeValue);
          break;
        case "1":
          that.timeValue = moment(that.timeValue)
            .add(val, "month")
            .format("YYYY-MM");
          that.changemonth(that.timeValue);
          break;
        case "2":
          that.timeValue = moment(that.timeValue)
            .add(val, "years")
            .format("YYYY");
          that.changeyear(that.timeValue);
          break;

        default:
          break;
      }
    },
    backToCurrent() {
      let that = this;
      switch (that.labelStatus) {
        case "0":
          that.timeValue = moment().format("YYYY-MM-DD");
          that.changeday(that.timeValue);
          break;
        case "1":
          that.timeValue = moment().format("YYYY-MM");
          that.changemonth(that.timeValue);
          break;
        case "2":
          that.timeValue = moment().format("YYYY");
          that.changeyear(that.timeValue);
          break;
        default:
          break;
      }
    },
    clear() {
      let that = this;
      that.timeValue = getToday()[0];
      that.labelStatus = "0";
      that.changeday(that.timeValue);
    },
    clear2() {
      let that = this;
      that.timeValue = getToday()[0];
      that.labelStatus = "0";
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
.dmyDateSelector {
  :deep() {
    .timebordernone-right {
      border-radius: 4px 0 0 4px !important;

      .el-input__wrapper {
        margin-left: 1px;
        border-radius: 4px 0 0 4px !important;
        border-right: none !important;
      }
    }
    .timebordernone-left {
      border-radius: 0px 4px 4px 0px !important;
      .el-input__wrapper {
        margin-right: 1px;
        border-radius: 0px 4px 4px 0px !important;
        border-left: none !important;
      }
    }
  }
}

.right-button {
  background-color: #f5f5f5;
  height: 32px;
  line-height: 32px;
  width: 60px;
  border: 1px solid #e6e6e6;
  box-sizing: border-box;
  border-left: 0px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  display: flex;
  align-items: center;
}

.right-button > div {
  width: 50%;
  text-align: center;
  height: 32px;
  line-height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.right-button > div:hover {
  background-color: #28b8c3;
  color: #fff;
}

.right-button > div:last-child {
  border-left: 1px solid #e6e6e6;
  box-sizing: border-box;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

.center-button {
  border: 1px solid #e6e6e6;
  box-sizing: border-box;
  height: 32px;
  line-height: 32px;
  width: 32px;
  text-align: center;
  background-color: #f5f5f5;
  cursor: pointer;
  font-size: 14px;
}
.center-button:hover {
  background-color: #28b8c3;
  color: #fff;
}
</style>
